import { useRouter } from 'next/router'

import { omit } from 'lodash'

export const toggleQueryParam = (router: ReturnType<typeof useRouter>, queryName: string, queryOnValue: string) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { [queryName]: _, ...newQuery } = router.query

  const hasNewPublishedParam = router.query[queryName] === queryOnValue

  if (!hasNewPublishedParam) {
    newQuery[queryName] = queryOnValue
  }

  void router.replace(
    {
      query: newQuery,
    },
    undefined,
    { scroll: false }
  )
}

export const removeQueryParams = async (router: ReturnType<typeof useRouter>, queryNames: string[]) => {
  await router.replace(
    {
      query: omit(router.query, queryNames),
    },
    undefined,
    { scroll: false }
  )
}

export const checkQueryExists = (router: ReturnType<typeof useRouter>, queryName: string) => {
  return !!router.query[queryName]
}
